import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import '@fontsource-variable/vazirmatn/wght.css';
import './index.css';
import App from './App';
import { ToastProvider } from './components/ui/ToastProvider';
import { setUnauthorizedHandler } from './api/apiClient';
import { logout } from './redux/slices/authSlice';
import { store } from './redux/store';
import { initializeApp } from './redux/slices/appSlice';

store.dispatch(initializeApp());
setUnauthorizedHandler(() => {
  store.dispatch(logout());
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastProvider>
        <HelmetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </ToastProvider>
    </Provider>
  </React.StrictMode>
);
